export default "__VITE_ASSET__DT93FrnO__"